module.exports = __webpack_public_path__ + "static/images/erweima.e24ca25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 0